/* ============================================================
   SOLARA CART FLOW
   1. Delivery promise countdown  [data-sdel]  (snippets/solara-delivery.liquid)
      Brisbane time (UTC+10, no daylight saving), Monday to Friday.
   2. Sleep System swap           [data-scs-swap] (snippets/solara-cart-system.liquid)
   3. Re-wires add-on rows after the cart drawer re-renders its contents.
   Loaded on every page from layout/theme.liquid. Safe to load more than once.
   ============================================================ */
(function () {
  if (window.SolaraCart) return;

  /* ---------- 1. Delivery promise ---------- */
  var BRISBANE_OFFSET_MIN = 10 * 60;
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  var parseCutoff = function (txt) {
    var m = String(txt || '3pm').toLowerCase().match(/(\d{1,2})(?:[:.](\d{2}))?\s*(am|pm)?/);
    if (!m) return 15 * 60;
    var h = parseInt(m[1], 10);
    var min = m[2] ? parseInt(m[2], 10) : 0;
    if (m[3] === 'pm' && h < 12) h += 12;
    if (m[3] === 'am' && h === 12) h = 0;
    if (!m[3] && h < 8) h += 12; /* a bare "3" means 3pm */
    return Math.min(h, 23) * 60 + min;
  };

  var brisbaneNow = function () {
    var now = new Date();
    var utcMin = now.getUTCHours() * 60 + now.getUTCMinutes() + now.getUTCSeconds() / 60;
    var day = now.getUTCDay();
    var local = utcMin + BRISBANE_OFFSET_MIN;
    if (local >= 1440) { local -= 1440; day = (day + 1) % 7; }
    return { day: day, minutes: local };
  };

  var deliveryText = function (cutoffMin) {
    var t = brisbaneNow();
    var weekday = t.day >= 1 && t.day <= 5;
    if (weekday && t.minutes < cutoffMin) {
      var left = Math.max(1, Math.floor(cutoffMin - t.minutes));
      var h = Math.floor(left / 60);
      var m = left % 60;
      var span = h > 0 ? (m > 0 ? h + 'h ' + m + 'm' : h + 'h') : m + ' min';
      return 'Order in the next <strong>' + span + '</strong> and it ships today';
    }
    var next = (t.day + 1) % 7;
    while (next === 0 || next === 6) next = (next + 1) % 7;
    var tomorrow = (t.day + 1) % 7 === next;
    return 'Order now and it ships <strong>' + (tomorrow ? 'tomorrow' : DAYS[next]) + ' morning</strong>';
  };

  var paintDelivery = function (root) {
    (root || document).querySelectorAll('[data-sdel]').forEach(function (el) {
      if (el.hasAttribute('data-paused')) return;
      var main = el.querySelector('[data-sdel-main]');
      if (!main) return;
      var cutoff = parseCutoff(el.getAttribute('data-cutoff'));
      var html = deliveryText(cutoff);
      if (main.innerHTML !== html) main.innerHTML = html;
      el.classList.add('is-live');
    });
  };

  /* ---------- 2. Sleep System swap ---------- */
  var postJSON = function (url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'Something went wrong. Please try again.');
        return d;
      });
    });
  };

  var onSwap = function (btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var box = btn.closest('[data-scs]');
    var msg = box && box.querySelector('[data-scs-msg]');
    var label = btn.querySelector('[data-scs-label]');
    var addId = Number(btn.getAttribute('data-add'));
    var lines;
    try { lines = JSON.parse(btn.getAttribute('data-remove') || '[]'); } catch (e) { lines = []; }
    if (!addId || !lines.length) return;

    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    if (label) label.textContent = 'Switching';
    if (msg) msg.textContent = '';

    var onCartPage = document.body.classList.contains('template-cart');
    var t = window.theme;
    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));

    var updates = {};
    lines.forEach(function (l) { updates[l.key] = Math.max(0, Number(l.qty) - 1); });

    var fail = function (text) {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      if (label) label.textContent = 'Switch to the Sleep System';
      if (msg) msg.textContent = text;
    };

    /* Bundle goes in first: if that fails, nothing has been taken out of the cart. */
    postJSON('/cart/add.js', { items: [{ id: addId, quantity: 1 }] })
      .catch(function (err) { fail(err.message); throw null; })
      .then(function () {
        var body = { updates: updates };
        if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
        return postJSON('/cart/update.js', body).catch(function () {
          /* Bundle added but the pieces are still there: show the real cart and say so. */
          if (onCartPage) { window.location.reload(); return null; }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
          fail('The Sleep System is in your cart. Remove the separate pieces to finish the switch.');
          return null;
        });
      })
      .then(function (state) {
        if (!state) return;
        if (onCartPage || !drawer || !t || !t.pubsub || !t.pubsub.PUB_SUB_EVENTS) { window.location.reload(); return; }
        return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var drawerId = drawer.getAttribute('data-section-id');
            if (!state.sections || !state.sections[drawerId]) {
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
              return;
            }
            cart.sections = state.sections;
            t.pubsub.publish(t.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'solara-swap', cart: cart });
            drawer.show();
          });
      })
      .catch(function (err) { if (err) fail(err.message || 'Something went wrong. Please try again.'); });
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-scs-swap]');
    if (btn) { e.preventDefault(); onSwap(btn); }
  });

  /* ---------- 3. Keep the drawer wired after it re-renders ---------- */
  var wire = function (root) {
    paintDelivery(root);
    if (window.SolaraAddons && typeof window.SolaraAddons.scan === 'function') {
      window.SolaraAddons.scan(root || document);
    }
  };

  /* The cart drawer and the cart page both swap their contents in place after every
     cart change, so watch both and re-wire add-on rows and the delivery line. */
  var observeDrawer = function () {
    if (!('MutationObserver' in window)) return;
    document.querySelectorAll('cart-drawer, main-cart').forEach(function (el) {
      if (el.__scObserved) return;
      el.__scObserved = true;
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; wire(el); });
      }).observe(el, { childList: true, subtree: true });
    });
  };

  var start = function () {
    wire(document);
    observeDrawer();
    setInterval(function () { paintDelivery(document); }, 30000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function (e) { wire(e.target); observeDrawer(); });

  window.SolaraCart = { paintDelivery: paintDelivery, parseCutoff: parseCutoff, deliveryText: deliveryText };
})();
